import { Trans, useTranslation } from "react-i18next";
import {
  ListItem,
  PrivacyPolicyText,
  SectionContainer,
  SectionSubTitle2,
  SectionTitle,
  SubSectionContainer,
} from "../PrivacyPolicyContent.styled";

export const DisclosurePersonalDataSectionContent = (
  props: DisclosurePersonalDataSectionContentProps
) => {
  const { i18n } = useTranslation();

  return (
    <SectionContainer>
      <SectionTitle>
        <Trans i18nKey={"privacyPolicy.disclosurePersonalData.title"} />
      </SectionTitle>
      <SubSectionContainer>
        <SectionSubTitle2>
          <Trans
            i18nKey={
              "privacyPolicy.disclosurePersonalData.otherLegalrequirements"
            }
          />
        </SectionSubTitle2>
        <PrivacyPolicyText>
          <Trans
            i18nKey={
              "privacyPolicy.disclosurePersonalData.otherLegalrequirementsText"
            }
          />
        </PrivacyPolicyText>
        <div>
          {(
            i18n.t(
              "privacyPolicy.disclosurePersonalData.otherLegalrequirementsList",
              {
                returnObjects: true,
              }
            ) as string[]
          ).map((definition, index) => (
            <ListItem
              key={index}
              dangerouslySetInnerHTML={{ __html: definition }}
            />
          ))}
        </div>
      </SubSectionContainer>
    </SectionContainer>
  );
};

export interface DisclosurePersonalDataSectionContentProps {}
